export default function Navbar({ isScrolled, activeSection, menuOpen, setMenuOpen, darkMode, setDarkMode, t }) {
  return (
    <nav className={`premium-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="#home" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-bracket">&lt;</span>
          <span className="logo-text">AO</span>
          <span className="logo-bracket">/&gt;</span>
        </a>

        <button className={`hamburger-btn ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span></span><span></span><span></span>
        </button>
        
        <ul className={`nav-list ${menuOpen ? 'open' : ''}`}>
          <li><a href="#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t.navHome}</a></li>
          <li><a href="#education-skills" className={`nav-link ${activeSection === 'education-skills' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>Edu & Skills</a></li>
          <li><a href="#experience" className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t.navExp}</a></li>
          <li><a href="#projects" className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t.navProj}</a></li>
          <li><a href="#certificates" className={`nav-link ${activeSection === 'certificates' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t.navCert}</a></li>
          <li><a href="#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t.navContact}</a></li>
          <li>
            <button onClick={() => { setDarkMode(!darkMode); setMenuOpen(false); }} className="theme-toggle-btn" aria-label="Toggle theme">
              {darkMode ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
              )}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
